import { useId } from "react"

import {
    getColorVariationFromPrimaryColorBasedOnIndex,
    getDarkerColorVariationFromPrimaryColorBasedOnIndex,
} from "./calculateColor"

// Provides the palette helpers together with collision-free SVG gradient ids.
//
// The color math is pure and safe to call any number of times, but the SVG
// <linearGradient> ids used by the pie charts must be unique per DOM element.
// When the same chart renders more than once on a page (e.g. StatusDiagram for
// both the initial and final status), hardcoded ids like `pie-gradient-0`
// collide and `url(#pie-gradient-0)` resolves to the first match in the DOM —
// so the second chart borrows the first chart's gradients. useId() gives each
// component instance its own suffix, keeping the ids unique.
export function useCalculateColor(namespace = "gradient") {
    // useId() output contains characters (":" / "«»") that aren't safe inside
    // an id attribute or a url(#...) reference, so strip everything but
    // alphanumerics.
    const uid = useId().replace(/[^a-zA-Z0-9]/g, "")

    const gradientId = (index) => `${namespace}-${uid}-${index}`
    const gradientUrl = (index) => `url(#${gradientId(index)})`

    return {
        getColorVariation: getColorVariationFromPrimaryColorBasedOnIndex,
        getDarkerColorVariation: getDarkerColorVariationFromPrimaryColorBasedOnIndex,
        gradientId,
        gradientUrl,
    }
}
